import { TransactionFormType } from 'typings/transactionForm';
import create from 'zustand';
import { persist } from 'zustand/middleware';

interface State {
  formType: TransactionFormType;
}

interface Actions {
  setFormType(formType: TransactionFormType): void;
}

const initialState: State = {
  formType: TransactionFormType.Classic,
};

const useTransactionFormStore = create(
  persist<State & Actions>(
    (set) => ({
      ...initialState,
      setFormType: (formType) => {
        set({ formType });
      },
    }),
    {
      name: '@fast-trade/shell-transaction-form',
    },
  ),
);

export default useTransactionFormStore;
